var paragraph_default = {
  "fontElementMap": "xQH8-",
  "elementSpacing": "xGHkc",
  "text": "hkh1Y xGHkc",
  "child": "VxFMC"
};
export {
  paragraph_default as default
};
//# sourceMappingURL=paragraph-scss.js.map
